/**
 * @generated SignedSource<<dbcee454a6e7068fd0bc4c192a976627>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppClipActionTitle = "OPEN" | "VIEW" | "%future added value";
export type AppStoreCategory = "BOOKS" | "BUSINESS" | "DEVELOPER_TOOLS" | "EDUCATION" | "ENTERTAINMENT" | "FINANCE" | "FOOD_AND_DRINK" | "GAMES" | "GRAPHICS_AND_DESIGN" | "HEALTH_AND_FITNESS" | "LIFESTYLE" | "MAGAZINES_AND_NEWSPAPERS" | "MEDICAL" | "MUSIC" | "NAVIGATION" | "NEWS" | "PHOTO_AND_VIDEO" | "PRODUCTIVITY" | "REFERENCE" | "SHOPPING" | "SOCIAL_NETWORKING" | "SPORTS" | "STICKERS" | "TRAVEL" | "UTILITIES" | "WEATHER" | "%future added value";
export type ScreensGeneratedContentInput = {
  account?: AccountTextInput | null;
  appListing?: AppListingTextInput | null;
  automation?: AutomationTextInput | null;
  notificationOptIn?: NotificationOptInTextInput | null;
  onboarding?: OnboardingTextInput | null;
};
export type NotificationOptInTextInput = {
  backgroundImage?: ReadonlyArray<string> | null;
  subtitle: string;
  title: string;
};
export type OnboardingTextInput = {
  backgroundImage?: ReadonlyArray<string> | null;
  rootTitle: string;
  upsellSubtitle: string;
  upsellTitle: string;
};
export type AccountTextInput = {
  deletionDialogTitle: string;
  deletionSubtitle: string;
  registerSubtitle: string;
  registerTitle: string;
  signInSubtitle: string;
  signInTitle: string;
};
export type AutomationTextInput = {
  abandonedBrowseNotifications: ReadonlyArray<BaseNotificationInput>;
  abandonedCartNotifications: ReadonlyArray<BaseNotificationInput>;
  abandonedCheckoutNotifications: ReadonlyArray<BaseNotificationInput>;
  reengagementNotifications: ReadonlyArray<NotificationWithLandingPathInput>;
  welcomeSeriesNotifications: ReadonlyArray<NotificationWithLandingPathInput>;
};
export type BaseNotificationInput = {
  message: string;
  title: string;
};
export type NotificationWithLandingPathInput = {
  landingPath: string;
  message: string;
  title: string;
};
export type AppListingTextInput = {
  appClipButtonText: AppClipActionTitle;
  appClipHeader?: ReadonlyArray<string> | null;
  appClipSubtitle: string;
  appDescription: string;
  appIcon?: ReadonlyArray<string> | null;
  appSubtitle: string;
  keywords: string;
  primaryCategory: AppStoreCategory;
  promotionalText: string;
  secondaryCategory: AppStoreCategory;
};
export type useBrandUpdateGeneratedContentMutation$variables = {
  brandId: string;
  data: ScreensGeneratedContentInput;
};
export type useBrandUpdateGeneratedContentMutation$data = {
  readonly saveAllScreensGeneratedText: boolean;
};
export type useBrandUpdateGeneratedContentMutation = {
  response: useBrandUpdateGeneratedContentMutation$data;
  variables: useBrandUpdateGeneratedContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "kind": "ScalarField",
    "name": "saveAllScreensGeneratedText",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBrandUpdateGeneratedContentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBrandUpdateGeneratedContentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf31922157b0db4b618ff8932d82398a",
    "id": null,
    "metadata": {},
    "name": "useBrandUpdateGeneratedContentMutation",
    "operationKind": "mutation",
    "text": "mutation useBrandUpdateGeneratedContentMutation(\n  $brandId: ID!\n  $data: ScreensGeneratedContentInput!\n) {\n  saveAllScreensGeneratedText(brandId: $brandId, data: $data)\n}\n"
  }
};
})();

(node as any).hash = "c60e32583291445bf5622d4a004f6afa";

export default node;
